import React from "react";
import {
  Leaf,
  FlaskConical,
  TestTube,
  ShieldCheck,
  Atom,
  Dna,
  Microscope,
  HeartPulse,
  Landmark,
  TrendingUp
} from "lucide-react";

import "../css/areastematicas.css";

const areas = [
  {
    text: "Botánica y etnobotánica de plantas medicinales.",
    icon: Leaf
  },
  {
    text: "Farmacología y etnofarmacología de especies medicinales.",
    icon: HeartPulse
  },
  {
    text: "Fitoquímica y química de especies medicinales.",
    icon: FlaskConical
  },
  {
    text: "Control de calidad, desarrollo, innovación y marco regulatorio de plantas medicinales.",
    icon: ShieldCheck
  },
  {
    text: "Química medicinal, química verde, relación estructura-actividad (SAR-QSAR) y estudios in silico de principios activos de plantas medicinales.",
    icon: Atom
  },
  {
    text: "Biotecnología, mejoramiento genético, cultivo, conservación y propagación de plantas medicinales.",
    icon: Dna
  },
  {
    text: "Genómica, metabolómica y transcriptómica aplicadas a la obtención de principios bioactivos de plantas medicinales.",
    icon: Microscope
  },
  {
    text: "Terapéutica y ensayos clínicos con plantas medicinales.",
    icon: TestTube
  },
  {
    text: "Gobernanza e institucionalidad para el acceso legal a recursos biológicos y genéticos de plantas medicinales y su conservación y uso sostenible.",
    icon: Landmark
  },
  {
    text: "Bioeconomía y cadenas de valor en productos naturales de plantas medicinales.",
    icon: TrendingUp
  }
];

function AreasTematicas() {
  return (
    <section className="areas-container">
      <h2 className="areas-title">Áreas <b>temáticas</b></h2>
      <p className="areas-description">
        Las áreas temáticas que se desarrollan en el evento son tópicos concernientes a:
      </p>

      <div className="areas-grid">
        {areas.map((area, index) => {
          const Icon = area.icon;

          return (
            <div key={index} className="area-card">
              <div className="area-icon-wrapper">
                <Icon className="area-icon" size={26} />
              </div>

              <span className="area-number">{index + 1}</span>
              <p>{area.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default AreasTematicas;